<template>
  <div>
    <CAcceptN1RedirectionModal @on-close="handleAcceptN1RedirectModalClose" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import CAcceptN1RedirectionModal from '../molecules/dialog/CAcceptN1RedirectionModal.vue'

export default {
  components: {
    CAcceptN1RedirectionModal
  },
  inject: ['notify'],
  computed: {
    ...mapGetters('pillars/channel', ['currentChannel'])
  },
  methods: {
    async handleAcceptN1RedirectModalClose(event) {
      if (event.detail === 'confirm') {
        const result = await this.$store.dispatch('channel/assignToN2Staff', {
          channelId: this.currentChannel.id
        })

        if (!result) {
          return
        } else {
          this.notify({
            icon: 'icCheckOutlined',
            duration: 3000,
            description: 'Ticket atribuído com sucesso!'
          })
        }
      }
    }
  }
}
</script>
